import app from '../firebase';
import {
    getFirestore,
    doc,
    collection,
    getDoc,
    writeBatch
} from 'firebase/firestore';

import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Cart() {
    var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' });
    const navigate = useNavigate();

    const userId = localStorage.getItem('userId');
    const [cart, setCart] = useState();

    // checkout
    const [total, setTotal] = useState(0);
    const [profile, setProfile] = useState(); // filled after successful implementation

    const getProfile = () => {
        if (!localStorage.getItem('userId')) return;
        getDoc(doc(getFirestore(app), 'users', localStorage.getItem('userId')))
            .then(result => setProfile([result.id, result.data()]))
    }

    const getCart = async () => {
        setCart(JSON.parse(localStorage.getItem('cart')));
    }

    const removeItem = async itemIndex => {
        let current_cart = JSON.parse(localStorage.getItem('cart'));
        current_cart = current_cart.filter((i, index) => index !== itemIndex);
        localStorage.setItem('cart', JSON.stringify(current_cart));
        setCart(current_cart);
    }

    const getTotal = async () => {
        if (!localStorage.getItem('cart')) return setTotal(0);
        let x = 0;
        let current_cart = JSON.parse(localStorage.getItem('cart'));
        await current_cart.forEach(i => x = x + i.amount * i.quantity);
        setTotal(x);
    }

    const checkout = async () => {

            const batch = writeBatch(getFirestore(app));
    
            cart.forEach(i => {
                batch.set(doc(collection(getFirestore(app), 'orders')), {
                    customer: {
                        id:             profile[0],
                        name:           profile[1].name,
                        email:          profile[1].email,
                        address:        profile[1].address.house + ' ' + profile[1].address.street + ' ' + profile[1].address.barangay + ' ' + profile[1].address.municipality + ' ' + profile[1].address.province + ' (' + profile[1].address.landmark + ')',
                        phone:          profile[1].phone
                    },
        
                    seller: {
                        id:             i.seller.id,
                        name:           i.seller.data.name,
                        email:          i.seller.data.email,
                        address:        i.seller.data.address.house + ' ' + i.seller.data.address.street + ' ' + i.seller.data.address.barangay + ' ' + i.seller.data.address.municipality + ' ' + i.seller.data.address.province + ' (' + i.seller.data.address.landmark + ')',
                        phone:          i.seller.data.phone
                    },
        
                    item: {
                        id:             i.item.id,
                        name:           i.item.data.name,
                        description:    i.item.data.description,
                        price:          parseFloat(i.item.data.price),
                        image_url:      i.item.data.image_url,
                        quantity:       parseInt(i.quantity),
                        amount:         parseFloat(i.amount)
                    },
        
                    status: 'ordered',
                    date: new Date()
                });
            })
    
            await batch.commit();

        setCart(); // remove items from cart so it won't duplicate
        localStorage.removeItem('cart');
        return window.location.replace('/checkout');
    }

    useEffect(() => {
        getProfile();
        getCart();
        getTotal();
    }, []);

    return(
        <>
            <div className="container-fluid bg-light p-4">

                <div className="container mx-4">
                <div className="row">
                    <div className="col-12 col-md-8">
                        <table className="table table-sm table-borderless text-center">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Product</th>
                                    <th scope="col">Price</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    cart && cart.map((i, index) => (
                                        <tr>
                                            
                                            {/* Image */}
                                            <td className="align-middle">
                                                <img src={i.item.data.image_url} className="img-fluid border rounded-3" style={{ width: 60 }} alt="" />
                                            </td>

                                            {/* Product Description */}
                                            <td className="align-middle d-none d-lg-block">
                                                <span className="d-block">{i.item.data.name}</span>
                                                <small className="d-block text-muted">{i.item.data.description.substring(0, 40)} ...</small>
                                            </td>

                                            {/* Price */}
                                            <td className="align-middle">
                                                <span className="d-block">{formatter.format(i.amount)}</span>
                                                { i.coupon && <small className="d-block text-danger text-decoration-line-through">{formatter.format(i.item.data.price)}</small> }
                                            </td>
                                            
                                            {/* Quantity */}
                                            <td className="align-middle">{i.quantity}</td>

                                            {/* Amount */}
                                            <td className="align-middle text-success fw-bold">{formatter.format(i.amount * i.quantity)}</td>

                                            {/* Action */}
                                            <td className="align-middle"><button className="btn btn-sm btn-danger rounded-circle" onClick={() => removeItem(index)}><i className="bi-x"></i></button></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>

                    <div className="col-12 col-md-4">

                        {/* total amount */}
                        <span className="d-block fs-4 fw-bold mb-2">Total: {total && formatter.format(total)}</span>
                        
                        {/* checkout */}
                        {
                            userId ?
                                <button className="btn btn-lg btn-dark w-100" onClick={checkout}><i className="bi-bag-check-fill"></i> Checkout</button>
                                :
                                <button className="btn btn-lg btn-dark w-100" onClick={() => { localStorage.setItem('redirect', '/cart'); navigate('/login'); }}>Please Login To Purchase Items</button>
                        }
                    </div>
                </div>
                </div>
                

            </div>
        </>
    )
}